import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  100% {
    transform: translateX(100%);
  }
`

export const SkeletonPlaceholder = styled.div`
    display: inline-block;
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: #dddbdd;
    border-radius: 5px;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.2) 20%,
            rgba(255, 255, 255, 0.5) 60%,
            rgba(255, 255, 255, 0)
        );
        animation: ${shimmer} 2s infinite;
        content: '';
    }
`
